import { Button } from "antd";
import styled from "styled-components";

/**
 * PRIMARY ACTION BUTTON — Gradient background, shadow, premium feel.
 * Large size (48px) for comfortable tap target. Used for the main action of
 * auth screens (login, registration).
 */
export const PrimaryButton = styled(Button)`
  &.ant-btn {
    background: var(--color-gradient) !important;
    border: none !important;
    border-radius: var(--radius-md);
    font-weight: var(--weight-semibold);
    font-size: var(--text-base);
    height: 48px;
    box-shadow: var(--shadow-primary);
    transition: var(--transition-all);

    &:hover {
      background: var(--color-gradient-hover) !important;
      box-shadow: var(--shadow-primary-lg);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  }
`;
